import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { AppDispatch } from "../../../redux/store";
import { updateBookingsQueryDetails } from "../../../redux/reducers/Properties/PropertiesSlice";
import type { Chat } from "../../../redux/reducers/ChatReducer/ChatSliceTypes";
import { BookingQuery } from "../types/messages.types";
import { UI_TEXT } from "../constants/messages.constants";

interface UseBookingActionsReturn {
  handleProceedToBooking: (
    bookingQuery: BookingQuery | null,
    bookingQueryId: number | null,
    selectedChat: Chat | null
  ) => void;
  handleProceedToPayment: (bookingId: number | null) => void;
}

/**
 * Custom hook for booking and booking query actions
 * Handles navigation to booking details and payment pages
 */
export const useBookingActions = (): UseBookingActionsReturn => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  /**
   * Navigate to booking query details page
   */
  const handleProceedToBooking = (
    bookingQuery: BookingQuery | null,
    bookingQueryId: number | null,
    selectedChat: Chat | null
  ) => {
    if (bookingQuery != null && bookingQueryId && selectedChat) {
      const payload = {
        id: bookingQueryId,
        propertyId: selectedChat.property.id,
        state: "accepted",
        checkIn: bookingQuery.check_in_date,
        checkOut: bookingQuery.check_out_date,
      };

      dispatch(updateBookingsQueryDetails(payload))
        .then((response) => {
          console.log("Booking updated successfully", response);
          navigate(`/booking_queries_details?id=${bookingQueryId}`);
        })
        .catch((error) => {
          console.error("Error in updating booking", error);
          toast.error(UI_TEXT.ERRORS.BOOKING_UPDATE_FAILED);
        });
    } else {
      toast.error(UI_TEXT.ERRORS.BOOKING_QUERY_MISSING);
    }
  };

  /**
   * Navigate to booking payment/details page
   */
  const handleProceedToPayment = (bookingId: number | null) => {
    if (bookingId) {
      navigate(`/booking_request?id=${bookingId}`);
    } else {
      toast.error(UI_TEXT.ERRORS.BOOKING_MISSING);
    }
  };

  return {
    handleProceedToBooking,
    handleProceedToPayment,
  };
};
